export default "__VITE_ASSET__BGa$V_KP__"